import Button from "../../common/Button";
import { ReactSVG } from "react-svg";
import React, { useState } from "react";
import NewToolTip from "../../common/New-ToolTip";
import ClinicalServiceCardToolTip from "../../common/tooltip/clinical-service-card";

const ClinicalServiceCard = ({
  title = "",
  varient = "primary-outline",
  comingSoon = false,
  comingSoonImage = null,
  titleOnly = false,
  disabled = false,
  isSelect = false,
  newServiceBtnOnClick = () => {},
  followUpBtnOnClick = () => {},
  selectBtnOnClick = () => {},
  isNote = false,
  noteTitle = "",
  noteSubTitle = "",
  noteDescription = "",
  iconName = "",
  position = "bottom",
}) => {
  const [show, setShow] = new useState(false);

  return (
    <div
      className={`relative flex flex-col  justify-between group p-5 rounded-[4px] h-full 
      ${disabled ? "bg-blue-100 opacity-50 overflow-hidden" : "bg-blue-100"}`}
    >
      {comingSoon ? (
        <div className="relative flex flex-col items-start justify-end w-full h-full overflow-hidden px-2 sm:px-3">
          {comingSoonImage && (
            <img
              src={comingSoonImage}
              alt=""
              className="absolute inset-0 w-full h-full object-cover"
            />
          )}

          <h4
            className={`relative z-10 font-semibold text-display-sm text-teal-200 ${
              titleOnly ? "mb-14" : ""
            }`}
          >
            {title}
          </h4>

          {!titleOnly && (
            <div className="relative z-10 mt-2 w-full">
              <Button
                type="primary-outline"
                text="Coming Soon"
                className="w-full border border-REELTeal text-teal-200 bg-blue-100"
                disabled
              />
            </div>
          )}
        </div>
      ) : (
        <>
          {iconName && (
            <div className="ml-auto mr-5">
              <img
                src={`/icons/${iconName}.svg`}
                alt="Reel"
                className={`${
                  iconName === "rx-minor-ailment" ? "mr-[30px]" : ""
                } object-cover max-h-[175px] opacity-10 group-hover:opacity-100 duration-1000 transition-transform origin-right transform group-hover:scale-125`}
              ></img>
            </div>
          )}
          <div className="mt-auto ml-3 mr-3">
            <div className="flex items-center mb-3">
              <h4 className="font-semibold text-teal-200 text-display-sm">
                {title}
              </h4>
              {isNote && (
                <div className="relative flex gap-2">
                  <ReactSVG
                    src="/icons/information-dark.svg"
                    className="w-6 mt-1 ml-6"
                    data-tooltip-id={noteTitle}
                  />
                  <NewToolTip
                    id={noteTitle}
                    render={() => (
                      <ClinicalServiceCardToolTip
                        noteTitle={noteTitle}
                        noteSubTitle={noteSubTitle}
                        noteDescription={noteDescription}
                      />
                    )}
                    place={position}
                    clickable={true}
                  />
                </div>
              )}
            </div>
            <div className="grid grid-cols-12 gap-3.5 relative">
              {isSelect ? (
                <Button
                  type={varient}
                  text="Select"
                  className="col-span-6 !px-2.5 !py-3.5"
                  onClick={selectBtnOnClick}
                />
              ) : (
                <>
                  <Button
                    type={"primary"}
                    text="New Service"
                    className="col-span-6 !px-2.5 !py-3.5 "
                    onClick={newServiceBtnOnClick}
                  />
                  <div 
                    className="col-span-6"
                    data-tooltip-id={`follow-up-tooltip-${title}`}
                  >
                    <Button
                      type={"primary-outline"}
                      text="Follow Up"
                      className="!px-2.5 !py-3.5 w-full"
                      onClick={followUpBtnOnClick}
                    />
                    <NewToolTip
                      id={`follow-up-tooltip-${title}`}
                      render={() => (
                        <div className="bg-gray-20 p-2 max-w-md">
                          <p className="text-teal-300 text-left text-body-sm font-normal">
                            Coming Soon
                          </p>
                        </div>
                      )}
                      place="top"
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ClinicalServiceCard;
